<template>
    <Head :title="__('Create user')"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('Create user') }}
            </h2>
        </template>
        <card-component @submit.prevent="submit" form>

            <field class="max-w-sm" :label="__('Name')" :error="errors.name ?? ''">
                <control :icon="mdiAccount" :placeholder="__('Name')" v-model="form.name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Email')" :error="errors.email ?? ''">
                <control :icon="mdiAt" :placeholder="__('Email')" v-model="form.email"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Password')" :error="errors.password ?? ''">
                <control :icon="mdiFormTextboxPassword" :placeholder="__('Password')" v-model="form.password"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Role')" :error="errors.role ?? ''">
                <control :icon="mdiAccountMultipleOutline" :options="role_options" v-model="form.role"
                         :required="true"/>
            </field>

            <jb-buttons class="justify-end">
                <jb-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                           type="success" color="success" :label="__('Create user')"/>
            </jb-buttons>
        </card-component>
    </BreezeDashboardLayout>
</template>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {ref, reactive, computed, defineProps, toRefs} from 'vue'
import {
    mdiAt,
    mdiAccount,
    mdiAccountMultipleOutline,
    mdiEmail,
    mdiFormTextboxPassword,
    mdiLink,
    mdiOpenInNew,
    mdiPuzzleOutline,
    mdiAvTimer,
    mdiTranslate,
    mdiNumeric8BoxMultipleOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        errors: Object,
        roles: Object
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '',
                role: this.role_options[0],
            })
        }
    },
    setup(props) {

        const role_options = []

        props.roles.forEach((role) => {
            const roleName = role.name.charAt(0).toUpperCase() + role.name.slice(1)
            role_options.push({id: role.id, label: roleName})
        })

        return {
            mdiAccount,
            mdiAccountMultipleOutline,
            mdiAt,
            mdiFormTextboxPassword,
            mdiLink,
            mdiOpenInNew,
            mdiEmail,
            mdiPuzzleOutline,
            mdiAvTimer,
            mdiTranslate,
            mdiNumeric8BoxMultipleOutline,
            role_options
        }
    },
    methods: {
        submit() {
            this.form.post(this.route('users.store'), {
                onFinish: () => this.form.reset('name')
            })
        }
    }
}
</script>
